export default __webpack_public_path__ + "static/media/FII.368d1568.svg";